import { Card, CardContent } from "@/components/ui/card";
import {
  TRANSFER_STAT_CARD,
  TRANSFER_STAT_CARD_BODY,
  TRANSFER_STAT_GRID_3,
} from "@/modules/inventory/presentation/ui/transfers/transferCardLayout";
import {
  ClockIcon,
  FilterIcon,
  TruckIcon,
} from "lucide-react";

type TransfersSummaryCardsProps = {
  submittedPending: number;
  shippedUnreceived: number;
  filteredTotal: number;
  isLoading?: boolean;
};

export function TransfersSummaryCards({
  submittedPending,
  shippedUnreceived,
  filteredTotal,
  isLoading,
}: TransfersSummaryCardsProps) {
  if (isLoading) {
    return (
      <div className={TRANSFER_STAT_GRID_3}>
        {[1, 2, 3].map((i) => (
          <Card key={i} className={TRANSFER_STAT_CARD}>
            <CardContent className={TRANSFER_STAT_CARD_BODY}>
              <div className="h-10 animate-pulse rounded bg-muted" />
              <div className="mt-2 h-6 w-16 animate-pulse rounded bg-muted" />
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  return (
    <div className={TRANSFER_STAT_GRID_3}>
      <Card className={`${TRANSFER_STAT_CARD} border-amber-500/20`}>
        <CardContent className={TRANSFER_STAT_CARD_BODY}>
          <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-amber-500/10">
            <ClockIcon className="size-5 text-amber-600" />
          </div>
          <div>
            <p className="text-muted-foreground text-sm">ລໍຖ້າອະນຸມັດ</p>
            <p className="font-semibold text-2xl tabular-nums">
              {submittedPending.toLocaleString("lo-LA")}
            </p>
          </div>
        </CardContent>
      </Card>

      <Card className={`${TRANSFER_STAT_CARD} border-blue-500/20`}>
        <CardContent className={TRANSFER_STAT_CARD_BODY}>
          <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-blue-500/10">
            <TruckIcon className="size-5 text-blue-600" />
          </div>
          <div>
            <p className="text-muted-foreground text-sm">ສົ່ງແລ້ວຍັງບໍ່ຮັບ</p>
            <p className="font-semibold text-2xl tabular-nums">
              {shippedUnreceived.toLocaleString("lo-LA")}
            </p>
          </div>
        </CardContent>
      </Card>

      <Card className={`${TRANSFER_STAT_CARD} border-emerald-500/20`}>
        <CardContent className={TRANSFER_STAT_CARD_BODY}>
          <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-emerald-500/10">
            <FilterIcon className="size-5 text-emerald-600" />
          </div>
          <div>
            <p className="text-muted-foreground text-sm">ຜົນຕາມຕົວກອງ</p>
            <p className="font-semibold text-2xl tabular-nums">
              {filteredTotal.toLocaleString("lo-LA")}
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
